export default {
    tabs: {
        favorites: "Favorites",
        fishing: "Fishing",
        slot: "Slot",
        table: "Table"
    },
    no_favorites: "there's nothing here yet.<br>add something",
    bottom: {
        balance: ({balance}) => `$${balance}`,
        avatar: "Profile Avatar",
        bonus: "Bonus",
        wheel: "Xp Bar",
        settings: "Settings"
    }
}